import React from 'react'
import PropTypes from 'prop-types'

const BoxUnconfirmed = ({ email }) => {
  return (
    <div className='col-12'>
      <h1 className='h1 color-brand-1 txt-circular-book mb-1'>
        Confirmar e-mail
      </h1>
      <p className='txt-body-sm'>Seu e-mail não foi confirmado.</p>
      <p className='txt-body-sm mb-1'>
        Verifique em seu e-mail cadastrado o link de confirmação.
      </p>
      <div className='row'>
        <p className='col-12 color-brand-1'>{email}</p>
      </div>
    </div>
  )
}

BoxUnconfirmed.propTypes = {
  email: PropTypes.string
}

export default BoxUnconfirmed
